"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analytics = void 0;
var logger_1 = require("../logger");
exports.analytics = {
    /**
     * @param analyticsDataLayer be aware that you should not be pushing sensitive data to analytics, see GDPR laws .
     */
    push: function (analyticsDataLayer) {
        var _a, _b;
        logger_1.logger.log("Analytics event", analyticsDataLayer);
        // @ts-ignore ignore for ts to be happy.
        window.dataLayer = (window === null || window === void 0 ? void 0 : window.dataLayer) || [];
        if (analyticsDataLayer && analyticsDataLayer.featureFlags) {
            var oldFlags_1 = analyticsDataLayer.featureFlags;
            analyticsDataLayer.featureFlags = Object.keys(oldFlags_1).reduce(function (flags, key) {
                var _a;
                flags[key.replace(/(\.|-)/g, '_')] = (_a = oldFlags_1[key]) !== null && _a !== void 0 ? _a : false;
                return flags;
            }, {});
        }
        // @ts-ignore ignore for ts to be happy.
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(__assign(__assign({}, analyticsDataLayer), (((_b = analyticsDataLayer === null || analyticsDataLayer === void 0 ? void 0 : analyticsDataLayer.action) === null || _b === void 0 ? void 0 : _b.type) && { event: analyticsDataLayer.action.type })));
    },
};
//# sourceMappingURL=analytics.js.map